import { Modal, Button } from "antd";
import { cancelCarpoolingTripByIdApi, cancelTripByIdApi } from "api/trips";
import WarningIcon from "components/Icons/WarningIcon";
import { useDataLoadingContext } from "contexts/DataLoadingContext";
import { useNotificationContext } from "contexts/NotificationContext";
import { ITripsModel } from "models/trips";
import { useState } from "react";

interface IProp {
  open: boolean;
  trip: ITripsModel;
  handleClose: () => void;
}

export default function CancelTripModal({ open, trip, handleClose }: IProp) {
  const [loading, setLoading] = useState<boolean>(false);
  const { showError, showSuccess } = useNotificationContext();
  const { loadTrips } = useDataLoadingContext();

  const handleCancelTrip = async () => {
    setLoading(true);
    if (trip.type === "carpooling") {
      const { data, error } = await cancelCarpoolingTripByIdApi(trip.id);
      if (data) {
        showSuccess("Carpooling Trip Cancelled successfully");
        loadTrips();
      } else showError(error!.message);
    } else {
      const { data, error } = await cancelTripByIdApi(trip.id);
      if (data) {
        showSuccess("Trip Cancelled successfully");
        loadTrips();
      } else showError(error!.message);
    }
    setLoading(false);
    handleClose();
  };

  return (
    <Modal open={open} title={null} footer={null} closeIcon={null} centered>
      <div className="w-full text-center">
        <div className="w-full text-orange-400 text-9xl flex justify-center my-6">
          <WarningIcon />
        </div>
        <h3 className="text-3xl font-semibold my-4">Are you sure?</h3>
        <p
          className="font-normal text-base"
          style={{ color: "rgba(0,0,0,.64)" }}
        >
          You're about to cancel this trip
        </p>
        <div className="w-full flex mt-7 items-center justify-end gap-x-3">
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleCancelTrip} loading={loading} type="primary">
            Confirm
          </Button>
        </div>
      </div>
    </Modal>
  );
}
